import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import '../utils/firebaseDebug'; // Load debug utility

// Your web app's Firebase configuration
// Get this from Firebase Console: Project Settings > General > Your apps > Firebase SDK snippet
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "YOUR_PROJECT_ID.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "YOUR_PROJECT_ID",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "YOUR_PROJECT_ID.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "YOUR_MESSAGING_SENDER_ID",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "YOUR_APP_ID"
};

// Check if Firebase is properly configured
export const isFirebaseConfigured = (): boolean => {
  const configured = firebaseConfig.apiKey !== "YOUR_API_KEY" && 
         firebaseConfig.projectId !== "YOUR_PROJECT_ID" &&
         firebaseConfig.apiKey !== undefined &&
         firebaseConfig.projectId !== undefined;
  
  // Log status in development
  if (process.env.NODE_ENV === 'development') {
    if (configured) {
      console.log('✅ Firebase is configured');
    } else {
      console.warn('⚠️ Firebase is not configured. Check your .env file and restart the dev server.');
      console.log('💡 Run checkFirebaseConfig() in the console to debug');
    }
  }
  
  return configured;
};

// Initialize Firebase
let app: FirebaseApp | undefined;
let db: Firestore | undefined;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  
  if (process.env.NODE_ENV === 'development' && isFirebaseConfigured()) {
    console.log('✅ Firebase initialized successfully');
  }
} catch (error) {
  console.warn('Firebase initialization error:', error);
  // db will be undefined, which will be handled in the service layer
}

export { db };

export default app;

